//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../../axios/axios.js'
import { formatTime, formatTrueFalse } from '../../../../components/helpers.js'
import { getSurplusStateConfig } from '../../../../forms/StockInventoryTask/stockInventoryTools.js'

import TableServer from '../../../../components/Table/Table.vue'
import TableCellObject from '../../../../components/Table/TableCellObject.vue'

export default {
  name: 'StockInventoryTasks',
  components: {
    TableServer,
    TableCellObject
  },
  props: {
    stockId: {
      type: Number,
      default: null
    },
    formId: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      additionalUrlParams: null,

      inventoryCompleteness: [],
      columns: [
        {
          name: 'requestKey',
          label: '№',
          align: 'left',
          field: row => row.request.key,
          sortable: true,
          defaultWidth: 30
        },
        {
          name: 'bpState',
          label: 'Статус',
          align: 'left',
          field: row => row.bp.state.name,
          sortable: true
        },
        {
          name: 'applicant',
          label: 'Заявитель',
          align: 'left',
          field: row => row.request.applicant,
          sortable: false,
          columnFormat: 'object',
          columnObjectType: 'employee'
        },
        {
          name: 'executor',
          label: 'Исполнитель',
          align: 'left',
          field: row => row.request.executor,
          sortable: false,
          columnFormat: 'object',
          columnObjectType: 'employee'
        },
        {
          name: 'stock',
          label: 'Склад',
          align: 'left',
          field: row => row.request.stock,
          sortable: false,
          columnFormat: 'object',
          columnObjectType: 'stock',
          defaultWidth: 130
        },
        {
          name: 'requestCreateTime',
          label: 'Дата/время создания заявки',
          align: 'left',
          field: row => row.request.createTime,
          sortable: true,
          format: formatTime,
          defaultWidth: 130
        },
        {
          name: 'startTimeRequired',
          label: 'Требуемое время начала инвентаризации',
          align: 'left',
          field: row => row.request.startTimeRequired,
          sortable: true,
          format: formatTime,
          defaultWidth: 130
        },
        {
          name: 'endTimeRequired',
          label: 'Требуемое время завершения инвентаризации',
          align: 'left',
          field: row => row.request.endTimeRequired,
          sortable: true,
          format: formatTime,
          defaultWidth: 130
        },
        {
          name: 'startTimeActual',
          label: 'Фактическое время начала инвентаризации',
          align: 'left',
          field: row => row.request.startTimeActual,
          sortable: true,
          format: formatTime,
          defaultWidth: 130
        },
        {
          name: 'endTimeActual',
          label: 'Фактическое время завершения инвентаризации',
          align: 'left',
          field: row => row.request.endTimeActual,
          sortable: true,
          format: formatTime,
          defaultWidth: 130
        },
        {
          name: 'endTimeOverdue',
          label: 'Срок нарушен',
          align: 'left',
          field: row => row.request.endTimeOverdue,
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 90
        },
        {
          name: 'inventoryCompleteness',
          label: 'Полнота инвентаризации',
          align: 'left',
          field: row => {
            const inventoryCompleteness = this.inventoryCompleteness.find(inventoryCompleteness => row.request.inventoryCompleteness === inventoryCompleteness.id)
            return inventoryCompleteness && inventoryCompleteness.name
          },
          sortable: true
        },
        {
          name: 'withdrawnToolRecordsPresent',
          label: 'Частичный отзыв результатов',
          align: 'left',
          field: row => row.request.withdrawnToolRecordsPresent,
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 90
        },
        {
          name: 'partialExecutionAllowed',
          label: 'Разрешено частичное выполнение',
          align: 'left',
          field: row => row.request.partialExecutionAllowed,
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 90
        },
        {
          name: 'earlyExecutionAllowed',
          label: 'Разрешено досрочное выполнение',
          align: 'left',
          field: row => row.request.earlyExecutionAllowed,
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 90
        },
        {
          name: 'fullyExecuted',
          label: 'План инвентаризации выполнен',
          labelTable: 'План<br>инвент-ции выполнен',
          align: 'left',
          field: row => row.request.fullyExecuted,
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 90
        },
        {
          name: 'shortfallDetected',
          label: 'Выявлена недостача',
          align: 'left',
          field: row => row.request.shortfallDetected,
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 90
        },
        {
          name: 'surplusDetected',
          label: 'Выявлены излишки',
          align: 'left',
          field: row => row.request.surplusDetected,
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 90
        },
        {
          name: 'surplusState',
          label: 'Статус сдачи излишков на склад',
          align: 'left',
          field: row => row.request.surplusState,
          format: surplusState => surplusState && surplusState.name,
          sortable: true
        },
        {
          name: 'regradingDetected',
          label: 'Выявлена пересортица',
          align: 'left',
          field: row => row.request.regradingDetected,
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 94
        },
        {
          name: 'additionalToolRecordsDetected',
          label: 'Выявлены дополнительные позиции',
          labelTable: 'Выявлены доп. позиции',
          align: 'left',
          field: row => row.request.additionalToolRecordsDetected,
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 90
        },
        {
          name: 'unknownToolRecordsDetected',
          label: 'Выявлены неизвестные позиции',
          labelTable: 'Выявлены неизвестные позиции',
          align: 'left',
          field: row => row.request.unknownToolRecordsDetected,
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 96
        },
        {
          name: 'externalResultClosed',
          label: 'Результат закрыт в 1С',
          labelTable: 'Результат закрыт в 1С',
          align: 'left',
          field: row => row.request.externalResultClosed,
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 96
        },
        {
          name: 'externalSynchronizationErrorType',
          label: 'Ошибка синхронизации с 1С',
          labelTable: 'Ошибка синхронизации с 1С',
          align: 'left',
          field: row => {
            const errorName = row.request.externalSynchronizationErrorType && row.request.externalSynchronizationErrorType.name || ''
            if (errorName) {
              const synchronizationName = row.request.externalSynchronizationType && row.request.externalSynchronizationType.name || ''
              return (synchronizationName ? synchronizationName + ':\n' : '') + errorName
            }
            return ''
          },
          sortable: true
        }
      ]
    }
  },
  created: function () {
    if (this.stockId) {
      this.additionalUrlParams = {
        stockId: this.stockId
      }
    }

    this.getInventoryCompleteness()
  },
  methods: {
    /**
     * Может вызываться извне
     */
    onUpdate: function () {
      const tableComponent = this.$refs.table
      if (tableComponent) {
        tableComponent.onUpdate()
      }
    },
    onTableLoadingChange: function (value) {
      this.$emit('loading-change', value)
    },

    onAddRecord: function () {
      const params = { id: 'create' }
      if (this.stockId) {
        params.inputAdditionalParams = {
          properties: {
            stock: this.stockId
          }
        }
      }
      this.$router.push({ name: 'stockInventoryTask', params: params })
    },
    getTdStyle: function (col, row) {
      if (col.name === 'earlyExecutionAllowed' || col.name === 'partialExecutionAllowed' || col.name === 'fullyExecuted') {
        if (row.request && row.request[col.name] != null) {
          if (row.request[col.name]) {
            return this.getColoredTdStyle('#ceffce', 'black') // green
          } else {
            return this.getColoredTdStyle('#ffcece', 'black') // red
          }
        }
      } else if (col.name === 'endTimeOverdue' || col.name === 'shortfallDetected' || col.name === 'surplusDetected' || col.name === 'regradingDetected' || col.name === 'additionalToolRecordsDetected' || col.name === 'unknownToolRecordsDetected' || col.name === 'withdrawnToolRecordsPresent' || col.name === 'externalResultClosed') {
        if (row.request && row.request[col.name] != null) {
          if (row.request[col.name]) {
            return this.getColoredTdStyle('#ffcece', 'black') // red
          } else {
            return this.getColoredTdStyle('#ceffce', 'black') // green
          }
        }
      } else if (col.name === 'externalSynchronizationErrorType') {
        if (row.request && row.request[col.name] != null) {
          return 'white-space: pre-line; ' + this.getColoredTdStyle('#ffcece', 'black') // red
        }
      } else if (col.name === 'bpState' && row.bp.state) {
        return this.getColoredTdStyle(row.bp.state.color, 'white')
      } else if (col.name === 'surplusState' && row.request.surplusState) {
        const stateConfig = getSurplusStateConfig(row.request.surplusState)
        if (stateConfig) {
          return this.getColoredTdStyle(stateConfig.cssColor, 'white')
        }
      }
    },
    getColoredTdStyle: function (bgColor, color, fontWeight = 500) {
      return `font-weight: ${fontWeight} !important;
          background-color: ${bgColor} !important;
          color: ${color} !important;
          border-bottom: solid #e0e0e0 1px;`
    },
    getInventoryCompleteness: function () {
      const params = new URLSearchParams()
      params.append('property', 'inventoryCompleteness')

      return axiosGet({
        url: '/service/delta/stockInventory/task/propertyValues?' + params.toString(),
        onSuccess: (response) => {
          this.inventoryCompleteness = response.data.result
        },
        onFailure: 'Ошибка загрузки'
      })
    }
  }
}

